import 'angular';

import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

import { CriticalMessagesService } from './critical-messages.service';
import { CriticalMessagesComponent } from './critical-messages.component';

angular.module('app-lite.messages.critical-messages', [])
  .directive('worCriticalMessages', downgradeComponent({ component: CriticalMessagesComponent } ))
  .service('criticalMessagesApi', downgradeInjectable(CriticalMessagesService));
